import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddFlavor({ open, onClose, setOpen }: ModalProps) {

  const [flavorName, setFlavorName] = useState("");
  const [color, setColor] = useState("#000000"); // default color

  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setColor(e.target.value);
  };

  const handleColorInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setColor(e.target.value);
  };

  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Flavor</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form">
            <div className="control_group">
              <label>Flavor Name</label>
              <TextField
                placeholder="Enter Name"
                fullWidth
                hiddenLabel
                value={flavorName}
                onChange={(e) => setFlavorName(e.target.value)}
              />
            </div>

            <div className="control_group">
              <label>Flavor Color Code</label>
              <div className="flex_input">

                {/* Color Picker */}
                <TextField
                  type="color"
                  fullWidth
                  hiddenLabel
                  value={color}
                  onChange={handleColorChange}
                />

                {/* HEX Code Text Input */}
                <TextField
                  fullWidth
                  hiddenLabel
                  value={color}
                  onChange={handleColorInput}
                />
              </div>
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
